import Group from '../group/tag-group';
import Tag, { type TagProps } from './tag';
import SquareTag from './square-tag';
import { DotTag, type DotTagProps } from './dot-tag';
import { variants as tagVariants } from './style';

export { Tag, Group, SquareTag, DotTag, tagVariants, type TagProps, type DotTagProps };
export default Tag;
